import CustomDialog from 'Components/CustomDialog'
import CustomLoadingButton from 'Components/CustomLoadingButton'
import {
  fetchAllTariffs,
  fetchTariffs,
  importSingleTariff
} from 'Services/ProductManagement/Features/Tariff/tariffSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import {
  All_TARIFFS_COUNT_PER_REQUEST,
  ROWS_PER_PAGE_DEFAULT,
  SORT_ORDER_ASC
} from 'Util/constants'
import SnackbarUtil from 'Util/Snackbar'
import UploadIcon from '@mui/icons-material/Upload'
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  TextField,
  Typography
} from '@mui/material'
import { unwrapResult } from '@reduxjs/toolkit'
import { useState } from 'react'
import { t } from 'ttag'

interface TariffImportDialogProps {
  open: boolean
  handleClose: () => void
}

export function TariffImportDialog({ open, handleClose }: Readonly<TariffImportDialogProps>) {
  const dispatch = useAppDispatch()
  const { submitLoading } = useTypedSelector(state => state.tariff)

  const [tariffId, setTariffId] = useState('')

  const importTariff = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    dispatch(importSingleTariff({ id: tariffId }))
      .then(unwrapResult)
      .then(() => {
        SnackbarUtil.success(t`Tariff successfully imported.`)
        dispatch(
          fetchTariffs({
            sort_order: SORT_ORDER_ASC,
            count: ROWS_PER_PAGE_DEFAULT
          })
        )
        // Updates the tariff list in the drawer
        dispatch(fetchAllTariffs({ bypass_pagination: true, count: All_TARIFFS_COUNT_PER_REQUEST }))
        handleClose()
      })
      .catch(() => {
        SnackbarUtil.error(t`There was an error importing the tariff.`)
      })
  }

  const isSubmitLoading = submitLoading === 'pending'

  return (
    <CustomDialog open={open} handleClose={handleClose}>
      <DialogTitle id="dialog-title">{t`Are you sure?`}</DialogTitle>
      <Box component="form" onSubmit={importTariff}>
        <DialogContent>
          <DialogContentText>
            <Box>
              <Typography
                component="span"
                color="text.primary"
              >{t`Are you sure you want to import tariff?`}</Typography>
            </Box>
            <Box mt={2}>
              <Typography
                component="span"
                color="text.primary"
              >{t`Tariff's id should be from the staging environment.`}</Typography>
            </Box>
            <Box mt={2}>
              <FormControl fullWidth size="small">
                <TextField
                  required
                  name="tariff_id"
                  value={tariffId}
                  label={t`Tariff's id`}
                  onChange={e => setTariffId(e.target.value)}
                />
              </FormControl>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t`Cancel`}
          </Button>
          <CustomLoadingButton
            size="medium"
            type="submit"
            variant="contained"
            loading={isSubmitLoading}
            startIcon={<UploadIcon />}
            endIcon={null}
          >
            {t`Import tariff`}
          </CustomLoadingButton>
        </DialogActions>
      </Box>
    </CustomDialog>
  )
}
